import api from "../utils/api";

export const sendPushNotification = async (data) =>
  await api.post("/notifications", data);
